import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function fadeTransition(show: boolean) {
  return cn(
    "overflow-hidden",
    "transition-[opacity,transform] duration-300 ease-in-out",
    {
      "translate-y-0 opacity-100 h-full": show,
      "translate-y-2 opacity-0 h-0": !show,
    }
  );
}

export const cleanBulletPoint = (text: string): string => {
  return text.replace(/^\s*(?:[•+-]|â€¢)\s*/, "").trim();
};

export const cleanCorruptedCharacters = (text: string): string => {
  return text
    .replace(/â€¢/g, "•") // Replace corrupted bullet points with proper ones
    .replace(/â€"/g, '"') // Replace corrupted quotes if they exist
    .replace(/â€¦/g, "…") // Replace corrupted ellipsis if they exist
    .trim();
};

// Function to get avatar color based on initials
export const getAvatarColor = (name: string) => {
  const initials = name
    .split(" ")
    .map(n => n[0])
    .join("");
  const colors = [
    "bg-purple-100 text-purple-700", // Light purple
    "bg-blue-100 text-blue-700", // Light blue
    "bg-pink-100 text-pink-700", // Light pink
    "bg-indigo-100 text-indigo-700", // Light indigo
    "bg-green-100 text-green-700", // Light green
    "bg-teal-100 text-teal-700", // Light teal
    "bg-orange-100 text-orange-700", // Light orange
    "bg-cyan-100 text-cyan-700", // Light cyan
  ];

  // Generate consistent color based on name
  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = initials.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

// Helper function to generate initials from team name
export const generateInitials = (name: string): string => {
  if (!name?.trim()) {
    return "";
  }

  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join("");
};
